import Helmet from 'react-helmet';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/App.scss';
import Addressbook from '../../addressbook/containers/Addressbook';
import {Route, Switch, withRouter} from 'react-router-dom';
import Auth from '../../account/containers/Auth';
import Order from '../../order/containers/Order';
import Orders from '../../orders/containers/Orders';
import Profile from '../../profile/containers/Profile';
import { connect } from 'react-redux';
import Settings from "../../settings/containers/Settings";
import Certificate from "../../certificate/containers/Certificate";
import TenantSelect from "../../tenant/containers/TenantSelect";
import {NoMatch} from "./NoMatch";
import MaintenanceAwareComponent from "../../../lib/api/components/MaintenanceAwareComponent";

class App extends Component {
    static propTypes = {
        children: PropTypes.node,
    }

    onRouteChanged() {
        window.NOTIFICATIONS = { success: null, error: null };
    }

    render() {
        const { dispatch, session } = this.props;

        return (
            <div className={styles.container}>
                <Helmet
                    defaultTitle='Takeback'
                    titleTemplate='%s - Takeback'
                />
                <MaintenanceAwareComponent dispatch={dispatch} session={session}>
                    <Switch>
                        <Route path='/addressbook' component={Addressbook}/>
                        <Route path='/auth' component={Auth}/>
                        <Route path='/order' component={Order}/>
                        <Route path='/orders' component={Orders}/>
                        <Route path='/profile' component={Profile}/>
                        <Route path='/settings' component={Settings}/>
                        <Route path='/certificate' component={Certificate}/>
                        <Route path='/select' component={TenantSelect}/>
                        <Route component={() => <NoMatch showFooter={true} />}/>
                    </Switch>
                </MaintenanceAwareComponent>
            </div>
        );
    }
}

export default withRouter(connect(state => ({
    session: state.session,
    dispatch: state.dispatch,
}))(App));
